export default __webpack_public_path__ + "static/media/brand-8.bebfd54f.jpg";